import config from 'config'

const customerApi = `${config.apiHost}`

export default {
    getResignList: {
        url: `${customerApi}/oem-customer/api/handover_stat`,
        type: 'GET',
    },

    getResignStat: {
        url: `${customerApi}/oem-customer/api/handover_stat/overview`,
        type: 'GET',
    },

    exportData: {
        url: `${customerApi}/oem-customer/api/handover_stat/export`,
        type: 'GET',
    },
}
